import React from "react";

const InvoiceTable = ({ data, startIndex = 0 }) => {
  return (
    <div className="mb-2 w-full overflow-hidden">
      <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse', fontSize: '9px' }}>
        <colgroup>
          <col style={{ width: '5%' }}  />
          <col style={{ width: '19%' }} />
          <col style={{ width: '8%' }}  />
          <col style={{ width: '8%' }}  />
          <col style={{ width: '13%' }} />
          <col style={{ width: '8%' }}  />
          <col style={{ width: '13%' }} />
          <col style={{ width: '26%' }} />
        </colgroup>
        <thead style={{ borderTop: '2px solid black', borderBottom: '2px solid black' }}>
          <tr>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>No.</th>
            <th style={{ padding: '5px 2px', textAlign: 'left' }}>AWB</th>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>ORIGIN</th>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>DEST</th>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>DATE</th>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>TYPE</th>
            <th style={{ padding: '5px 2px', textAlign: 'center' }}>WEIGHT (Kg)</th>
            <th style={{ padding: '5px 2px', textAlign: 'right' }}>AMOUNT (IDR)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx} style={{ verticalAlign: 'top' }}>
              <td style={{ padding: '3px 2px', textAlign: 'center' }}>{startIndex + idx + 1}</td>
              <td style={{ padding: '3px 2px', textAlign: 'left', fontWeight: '500', wordBreak: 'break-all' }}>{item.awb}</td>
              <td style={{ padding: '3px 2px', textAlign: 'center', textTransform: 'uppercase' }}>{item.origin}</td>
              <td style={{ padding: '3px 2px', textAlign: 'center', textTransform: 'uppercase' }}>{item.destination}</td>
              <td style={{ padding: '3px 2px', textAlign: 'center' }}>
                {new Date(item.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })}
              </td>
              <td style={{ padding: '3px 2px', textAlign: 'center', fontWeight: 'bold', fontSize: '8px' }}>{item.service_type}</td>
              <td style={{ padding: '3px 2px', textAlign: 'center' }}>{item.weight_gram ? (item.weight_gram / 1000) : item.weight_kg}</td>
              <td style={{ padding: '3px 2px', textAlign: 'right', fontWeight: '500' }}>
                {(item.base_price || 0).toLocaleString('id-ID')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;